const SURVEY_TYPE = {
  rating: 'rating',
  choices: 'choices',
};

export default SURVEY_TYPE;
